import { useRef } from "react";
import type { ClipboardEvent, KeyboardEvent } from "react";
import { AUTOCOMPLETE_BLOQUEADO } from "../../utils/autofillNavegador";
import styles from "./CampoCodigoOtp.module.css";

interface CampoCodigoOtpProps {
  valor: string;
  onChange: (valor: string) => void;
  tamanho?: number;
  disabled?: boolean;
  autoFoco?: boolean;
}

/** Campo de código de verificação (2FA) em caixas individuais, com auto-avanço e colagem. */
export function CampoCodigoOtp({ valor, onChange, tamanho = 6, disabled = false, autoFoco = false }: CampoCodigoOtpProps) {
  const refs = useRef<Array<HTMLInputElement | null>>([]);
  const digitos = Array.from({ length: tamanho }, (_, indice) => valor[indice] || "");

  function definirDigito(indice: number, valorDigitado: string) {
    const limpo = valorDigitado.replace(/\D/g, "").slice(-1);
    const proximos = digitos.slice();
    proximos[indice] = limpo;
    onChange(proximos.join(""));
    if (limpo && indice < tamanho - 1) refs.current[indice + 1]?.focus();
  }

  function aoTeclar(indice: number, evento: KeyboardEvent<HTMLInputElement>) {
    if (evento.key === "Backspace" && !digitos[indice] && indice > 0) {
      refs.current[indice - 1]?.focus();
    }
  }

  function aoColar(evento: ClipboardEvent<HTMLInputElement>) {
    const colado = evento.clipboardData.getData("text").replace(/\D/g, "").slice(0, tamanho);
    if (!colado) return;
    evento.preventDefault();
    onChange(colado);
    refs.current[Math.min(colado.length, tamanho - 1)]?.focus();
  }

  return (
    <div className={styles.wrap}>
      {digitos.map((digito, indice) => (
        <input
          key={indice}
          ref={(el) => { refs.current[indice] = el; }}
          className={styles.caixa}
          value={digito}
          onChange={(evento) => definirDigito(indice, evento.target.value)}
          onKeyDown={(evento) => aoTeclar(indice, evento)}
          onPaste={aoColar}
          inputMode="numeric"
          maxLength={1}
          autoComplete={AUTOCOMPLETE_BLOQUEADO}
          disabled={disabled}
          autoFocus={autoFoco && indice === 0}
          aria-label={`Dígito ${indice + 1} do código de verificação`}
        />
      ))}
    </div>
  );
}
